if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          mobileViewer: this.querySelector('[id^="MobileMetaGallery"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          numbers: this.querySelector('[id^="GalleryThumbnailNumbers"]'),
        };


        this.init();

        window.addEventListener('pageshow', (event) => {
          if (event.persisted) this.init();
        });

        this.triggerElements = this.elements.thumbnails || this.elements.numbers;

        this.mql = window.matchMedia('(min-width: 750px)');

        if (!this.triggerElements) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.mobileViewer?.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));

        this.triggerElements.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      init() {
        if (!window.matchMedia('(min-width: 750px)').matches && this.elements.viewer?.classList.contains('small-hide')) {
          return;
        }
        const onloadTraget = this.querySelector('.product__media-item.is-active');
        if (!onloadTraget) return;

        const slider = onloadTraget.parentElement;
        const galleryWrapper = slider.closest('slider-component') || slider;
        slider.classList.add('scroll-snap-disabled');
        if (!window.matchMedia('(min-width: 750px)').matches && onloadTraget.offsetParent !== null) {
          galleryWrapper.classList.add('gallery-settling');
          setTimeout(() => galleryWrapper.classList.remove('gallery-settling'), 800);
        }

        this.setActiveMedia(onloadTraget.dataset.mediaId, true);

        const finalizeScrollPosition = () => {
          if (!window.matchMedia('(min-width: 750px)').matches || this.triggerElements) {
            this.holdActiveMediaPosition(onloadTraget, slider);
          } else {
            slider.classList.remove('scroll-snap-disabled');
          }
        };

        if (document.readyState === 'complete') {
          finalizeScrollPosition();
        } else {
          window.addEventListener('load', finalizeScrollPosition, { once: true });
        }
      }

      forceRepaint(el) {
        const previous = el.style.webkitOverflowScrolling;
        el.style.webkitOverflowScrolling = 'auto';
        void el.offsetHeight;
        el.style.webkitOverflowScrolling = previous || 'touch';
      }

      holdActiveMediaPosition(activeMedia, slider, endTime = performance.now() + 1200) {
        requestAnimationFrame(() => {
          if (activeMedia.clientWidth > 0 && Math.abs(slider.scrollLeft - activeMedia.offsetLeft) > 1) {
            slider.scrollTo({ left: activeMedia.offsetLeft, behavior: 'auto' });
            this.forceRepaint(slider);
          }
          if (performance.now() < endTime) {
            this.holdActiveMediaPosition(activeMedia, slider, endTime);
          } else {
            this.forceRepaint(slider);
            slider.classList.remove('scroll-snap-disabled');
            (slider.closest('slider-component') || slider).classList.remove('gallery-settling');
          }
        });
      }

      onSlideChanged(event) {
        if (event?.detail?.currentElement) {
          const thumbnail = this.triggerElements.querySelector(
            `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
          );
          this.setActiveThumbnail(thumbnail);
        }
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.mobileViewer?.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }

        // The mobile-metafield image set (.mobile-metafield-image) is a separate
        // slider with its own media-id namespace, shown instead of the regular
        // viewer on mobile when it's present, so it needs to be kept in sync too.
        const activeContainer = this.elements.mobileViewer?.contains(activeMedia)
          ? this.elements.mobileViewer
          : this.elements.viewer;

        [this.elements.viewer, this.elements.mobileViewer].forEach((container) => {
          container?.querySelectorAll('[data-media-id]').forEach((element) => {
            element.classList.remove('is-active');
          });
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          if(window.matchMedia('(min-width: 750px)').matches) activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (activeContainer.slider) activeContainer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.triggerElements) {
            this.scrollToActiveMediaWhenReady(activeMedia);
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          //window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.triggerElements) return;
        const activeThumbnail = this.triggerElements.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      scrollToActiveMediaWhenReady(activeMedia, attemptsLeft = 20) {
        if (activeMedia.offsetParent === null) return;
        requestAnimationFrame(() => {
          const galleryWrapper = activeMedia.parentElement.closest('slider-component') || activeMedia.parentElement;
          if (activeMedia.clientWidth > 0) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft, behavior: 'auto' });
            galleryWrapper.classList.remove('gallery-settling');
            return;
          }
          if (attemptsLeft > 0) {
            this.scrollToActiveMediaWhenReady(activeMedia, attemptsLeft - 1);
          } else {
            galleryWrapper.classList.remove('gallery-settling');
          }
        });
      }

      setActiveThumbnail(thumbnail) {
        if (!this.triggerElements || !thumbnail) return;

        this.triggerElements
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);

        if(this.elements.numbers) {
          this.elements.numbers.querySelectorAll('.thumbnail__number').forEach(el => el.classList.remove('is-active'));
          thumbnail.classList.add('is-active')
        }

        if (this.elements.thumbnails && this.elements.thumbnails.isSlideVisible(thumbnail, 10))  return;

        if (this.elements.thumbnails) this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
